import dayjs from 'dayjs';

export const checkExpiredChat = (createdAtUtc: Date | string) => {
    return dayjs(new Date()).add(-7, 'day').isAfter(dayjs(createdAtUtc).local());
}